/* Some commonly used filters */
import Vue from 'vue';
import vueMoment from 'vue-moment';
Vue.filter('stripHtml', (value) => {
    const div = document.createElement('div');
    div.innerHTML = value;
    // eslint-disable-next-line unicorn/prefer-text-content
    return div.textContent || div.innerText || '';
});
Vue.use(vueMoment);
// vue-moment filter is unnecessarily noisy if the input value is empty (0, empty string, null, etc)
// So we monkey patch it to quietly do that "empty?" check ourselves before calling the real filter
const realVueMomentFilter = Vue.options.filters.moment;
Vue.filter('moment', (...args) => {
    if (!args[0]) {
        return args[0];
    }
    return realVueMomentFilter(...args);
});
const terms = {
    '1': 'Winter',
    '3': 'Spring',
    '4': 'Summer',
    '5': 'Fall',
};
Vue.filter('yearTerm', (yearTerm) => {
    const string = '' + yearTerm;
    if (string.length !== 5) {
        return yearTerm;
    }
    const termNumber = yearTerm.substr(4);
    if (!terms[termNumber]) {
        return yearTerm;
    }
    const year = yearTerm.substr(0, 4);
    return `${terms[termNumber]} ${year}`;
});
//# sourceMappingURL=filters.js.map